export const namespace = 'alertFilters'
